import { initSlider, fillTopSlider } from './news';
import news_data from './data';
import RepeatedTask from '../utils/repeated_task';

const loaderEl = document.querySelector('.preloader');
const showLoader = () => loaderEl.classList.remove('hidden-el');
const hideLoader = () => loaderEl.classList.add('hidden-el');

export default config => {
    // updates slider when category is clicked
    const loadNews = function (categoryId) {
        //categories are rendered server-side immediately
        const categories =  config.currentSource.categories;
        //todo make fallback if no categories?
        const apiBaseUri = config.news_client;
        const urlTemplate = apiBaseUri + '/api/news?category=#CATEGORY_ID#&domain=#SITE#&language=#LNG#&limit=28&offset=0&source=#SOURCE_ID#';
        news_data.getFeedData(
            config.currentSource.id,
            urlTemplate,
            config.fallback_lang,
            categoryId,
            function (feedData) {
                //todo just fill news items and highlight clicked category!
                //categories should be rendered once
                fillTopSlider(feedData, categories, categoryId);
                config.isCategoryLoaded = true;
                hideLoader();
            }
        );
    }

    document.addEventListener("DOMContentLoaded", () => {
        // On load categories are loaded but when clicked until category clicked is rendered this param is false
        config.isCategoryLoaded = true;
        window.topNewsReload = new RepeatedTask(function () {
            if (document.visibilityState === "hidden") {
                return false; // stuck
            }
            if (document.querySelector('.carousel-slide')) {
                initSlider();
            } else {
                //no news from server-side- load via ajax
                loadNews(news_data.categoryTop);
            }

            return true;
        }, config.reload_interval);

        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === "hidden") {
                return;
            }

            if (window.topNewsReload.stuck) {
                window.topNewsReload.run();
            }
        });

        // //switch slider with our custom arrow
        // document.querySelector('.wrap-carousel').addEventListener('click', e => {
        //     const sliderWrapper = document.querySelector('.blaze-slider');
        //     if (!sliderWrapper.blazeSlider) {
        //         return;
        //     }
        //     const slider = sliderWrapper.blazeSlider;
        //     if (e.target.matches('.carousel-control-prev')) {
        //         slider.prev(1);
        //     }
        //     if (e.target.matches('.carousel-control-next')) {
        //         slider.next(1);
        //     }
        // });

        /*
        Switching categories event
        */
        const topSliderEl = document.querySelector('.col-carousel .news-categories');
        console.log('add event listener');
        topSliderEl.addEventListener('click', function (e) {
            e.preventDefault();
            const tg = e.target;
            if (tg.tagName !== 'A' || tg.closest('.news-categories') === null) {
                return;
            }

            //check if previous category click is loaded before allowing new category to be clicked
            if (!config.isCategoryLoaded) {
                setTimeout(function(){
                    tg.click(); //try again
                }, 100);

                return false;
            }
            showLoader();

            config.isCategoryLoaded = false; //reset category loaded status

            window.topNewsReload.postpone();

            loadNews(tg.dataset.filtercategory);

            return false;
        });
        //todo count news clicks in news.inbox.lv instead. pass portal as origin via query param or read Origin header
    });
};
